import i18n from "i18next";

import { IdNamePair } from "@/shared/domain/utils";

import { getSpApi, requestConfig } from "./apiRoot";
import { UrlManager } from "./UrlManager";

// Swagger: https://ibpcsrcdev01.portima.net/mybrokerapi/swagger/index.html

const getStringArray = async (url: string): Promise<string[]> => {
    const axiosRequestConfig = requestConfig({ params: { language: i18n.language } });
    const { data } = await getSpApi().get<string[]>(url, axiosRequestConfig);
    return data;
};

export const getBrands = async (): Promise<string[]> => {
    return getStringArray(UrlManager.vehiclesBrands());
};

export const getModels = async (brand: string): Promise<string[]> => {
    return getStringArray(UrlManager.vehiclesModels(brand));
};

export interface ApiVehiclesFueltypeWithLanguage extends Paths.ApiVehiclesFueltype.Get.QueryParameters {
    language?: string;
}

export const getFuelType = async (brand: string, model: string): Promise<IdNamePair[]> => {
    const axiosRequestConfig = requestConfig<ApiVehiclesFueltypeWithLanguage>({
        params: { brand, model, language: i18n.language },
    });
    const { data } = await getSpApi().get<IdNamePair[]>(UrlManager.vehiclesFuelType(), axiosRequestConfig);
    return data;
};

export const getCarInfos = async (brand: string, model: string): Promise<string[]> => {
    return getStringArray(UrlManager.vehiclesInfo(brand, model));
};

export const getCarInfo = async (vehicleId: string, policyholderId: number): Promise<MyBrokerApi.Vehicle> => {
    const config = requestConfig<Paths.ApiVehicles$Id.Get.QueryParameters>({ params: { policyholderId } });
    const { data } = await getSpApi().get<MyBrokerApi.Vehicle>(UrlManager.vehicleInfo(vehicleId), config);
    return data;
};

export const getPolicyholderVehicles = async (
    policyholderId: number | string,
): Promise<MyBrokerApi.AvailableVehicle[]> => {
    const config = requestConfig({ params: { language: i18n.language } });
    const { data } = await getSpApi().get<MyBrokerApi.AvailableVehicle[]>(
        UrlManager.policyholderVehicles(policyholderId),
        config,
    );
    return data;
};

export const getCoverage = async (firstRegistrationDate?: Date | null): Promise<MyBrokerApi.Coverages> => {
    const config = requestConfig({
        params: { language: i18n.language, firstRegistrationDate },
    });
    const { data } = await getSpApi().get<MyBrokerApi.Coverages>(UrlManager.vehiclesCoverage(), config);
    return data;
};
